export interface FullScreenElement extends HTMLDivElement {
  mozRequestFullScreen?: () => Promise<void>;
  webkitRequestFullscreen?: () => Promise<void>;
  msRequestFullscreen?: () => Promise<void>;
}

interface FullScreenIOSElement extends HTMLVideoElement {
  webkitEnterFullScreen?: () => Promise<void>;
}

interface FullScreenDocument extends Document {
  webkitFullscreenEnabled?: boolean;
  mozFullScreenEnabled?: boolean;
  msFullscreenEnabled?: boolean;
  webkitFullscreenElement?: Element;
  mozFullScreenElement?: Element;
  msFullscreenElement?: Element;
}
export const requestFullscreen = (element: FullScreenElement) => {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
};

export const requestFullscreenMobileIOS = (element: FullScreenIOSElement) => {
  if (element.webkitEnterFullScreen) {
    element.webkitEnterFullScreen();
  }
};

export const exitFullscreen = () => {
  if (typeof document === "undefined") return;

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if ((document as any).webkitExitFullscreen) {
    (document as any).webkitExitFullscreen();
  } else if ((document as any).mozCancelFullScreen) {
    (document as any).mozCancelFullScreen();
  } else if ((document as any).msExitFullscreen) {
    (document as any).msExitFullscreen();
  }
};

export const fullscreenEnabled = (): boolean => {
  const doc = document as FullScreenDocument;
  return (
    doc.fullscreenEnabled || doc.webkitFullscreenEnabled || doc.mozFullScreenEnabled || doc.msFullscreenEnabled || false
  );
};

export const isFullscreen = (): boolean => {
  if (typeof document === "undefined") return false;
  const doc = document as FullScreenDocument;
  return (
    !!doc.fullscreenElement || !!doc.webkitFullscreenElement || !!doc.mozFullScreenElement || !!doc.msFullscreenElement
  );
};
